import { render, staticRenderFns } from "./clothing.vue?vue&type=template&id=01c4f072&scoped=true"
import script from "./clothing.vue?vue&type=script&lang=js"
export * from "./clothing.vue?vue&type=script&lang=js"
import style0 from "./clothing.vue?vue&type=style&index=0&id=01c4f072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4f072",
  null
  
)

export default component.exports